import { defineNuxtPlugin } from '#app'
import { baiduKey } from '~/utils/common'
// @ts-ignore
import BaiduMap from 'vue-baidu-map-3x'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(BaiduMap, {
    ak: baiduKey // 替换为你的百度地图密钥
  })
})
